import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export abstract class Unsubsribe implements OnDestroy {
  unsub$ = new Subject<void>();

  ngOnDestroy(): void {
    this.unsub$.next();
    this.unsub$.complete();
  }

  unsubsribe(): void {
    this.unsub$.next();
    this.unsub$.complete();
  }
}
